import { render, staticRenderFns } from "./epb-bulk-action.component.vue?vue&type=template&id=4c82c13d&scoped=true"
import script from "./epb-bulk-action.component.vue?vue&type=script&lang=ts"
export * from "./epb-bulk-action.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-bulk-action.component.vue?vue&type=style&index=0&id=4c82c13d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c82c13d",
  null
  
)

export default component.exports